import React, { Component } from 'react';
import { SocialIcon } from 'react-social-icons';

class Ticker extends Component {


    render() {

        return (

            <div class="ticker-wrap">
            <div class="ticker">
              <div class="ticker__item">Diamond Bunny Club</div>
              <div class="ticker__item">Diamond Bunny Club</div>
              <div class="ticker__item">Diamond Bunny Club</div>
              <div class="ticker__item">Diamond Bunny Club</div>
              <div class="ticker__item">Diamond Bunny Club</div>
              <div class="ticker__item">Diamond Bunny Club</div>
              <div class="ticker__item">Diamond Bunny Club</div>
              <div class="ticker__item">Diamond Bunny Club</div>
              <div class="ticker__item">Diamond Bunny Club</div>
              <div class="ticker__item">Diamond Bunny Club</div>
              <div class="ticker__item">Diamond Bunny Club</div>
              <div class="ticker__item">Diamond Bunny Club</div>
              <div class="ticker__item">Diamond Bunny Club</div>
              <div class="ticker__item">Diamond Bunny Club</div>
              <div class="ticker__item">Diamond Bunny Club</div>
              <div class="ticker__item">Diamond Bunny Club</div>
              <div class="ticker__item">Diamond Bunny Club</div>
              <div class="ticker__item">Diamond Bunny Club</div>
            </div>
            </div>)
    }
}

export default Ticker;